<div [formGroup]="locationFormGroup" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="name"
    [placeholder]="'rentModule.locationDialogComponent.form.name.placeholder' | translate"
    [label]="'rentModule.locationDialogComponent.form.name.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="label"
    [label]="'rentModule.locationDialogComponent.form.label.label' | translate">
  </nx-edit-text-input>
  <nx-edit-chips-input
    formControlName="externalIds"
    [helpText]="'rentModule.locationDialogComponent.form.externalIds.helpText' | translate"
    [label]="'rentModule.locationDialogComponent.form.externalIds.label' | translate">
  </nx-edit-chips-input>
  <nx-edit-text-input
    formControlName="email"
    [placeholder]="'rentModule.locationDialogComponent.form.email.placeholder' | translate"
    [label]="'rentModule.locationDialogComponent.form.email.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="phoneNumber"
    [placeholder]="'rentModule.locationDialogComponent.form.phoneNumber.placeholder' | translate"
    [label]="'rentModule.locationDialogComponent.form.phoneNumber.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="web"
    [placeholder]="'rentModule.locationDialogComponent.form.web.placeholder' | translate"
    [label]="'rentModule.locationDialogComponent.form.web.label' | translate">
  </nx-edit-text-input>
  <nx-edit-multiselect-input
    [label]="'rentModule.locationDialogComponent.form.type.label' | translate"
    [options]="types | translateLabels"
    formControlName="type"
    [placeholder]="'rentModule.locationDialogComponent.form.type.placeholder' | translate">
    <ng-template let-option>
      {{option?.name | translate}}
    </ng-template>
  </nx-edit-multiselect-input>
</div>
<div>